import { v4 as uuidv4 } from 'uuid'

export const CUSTOM_DATES = 'custom_dates'
export const DATE = 'date'

export const getInitialValues = bookedMediaItem => {
  return {
    [CUSTOM_DATES]:
      bookedMediaItem?.[CUSTOM_DATES].map(customDate => ({
        [DATE]: new Date(customDate),
        id: uuidv4()
      }))
        // Sort the custom dates in ascending order
        .sort((a, b) => a[DATE] - b[DATE]) || []
  }
}
